import type { VacationDpRow } from '../models/vacationDpBoard.types';
import type { VacationRequestStatus } from '../models/vacation.types';
import { resolveBalanceHint } from './vacationDpDeadline';
import { getModalityLabel } from '../vacations.definitions';

export const OPEN_REQUEST_STATUSES: readonly VacationRequestStatus[] = [
    'PendingManager',
    'PendingClient',
    'PendingDP',
    'PendingCorrection',
    'Scheduled',
    'OnVacation',
];

export function hasOpenRequest(row: VacationDpRow): boolean {
    return row.request !== null && OPEN_REQUEST_STATUSES.includes(row.request.status);
}

export interface DpDaysInfo {
    value: number;
    kind: 'requested' | 'balance' | 'expired';
    hint: string | null;
}

export function resolveDpDays(row: VacationDpRow): DpDaysInfo {
    if (hasOpenRequest(row)) {
        const hint = row.request!.modality !== '30' ? getModalityLabel(row.request!.modality) : null;
        return {
            value: row.request!.totalDays,
            kind: 'requested',
            hint,
        };
    }

    if (row.expiredDays > 0) {
        return {
            value: row.expiredDays,
            kind: 'expired',
            hint: row.daysWithinDeadline > 0 ? `${row.daysWithinDeadline}d no prazo` : null,
        };
    }

    if (row.approvedPeriods && row.approvedPeriods.length > 0) {
        const approvedNotCompleted = row.approvedPeriods.filter((p) => p.status !== 'Completed');
        if (approvedNotCompleted.length > 0) {
            const total = approvedNotCompleted.reduce((sum, p) => sum + p.days, 0);
            return {
                value: total,
                kind: 'requested',
                hint: null,
            };
        }
    }

    return {
        value: row.daysWithinDeadline,
        kind: 'balance',
        hint: resolveBalanceHint(row),
    };
}
